import React from 'react';
import './styles.scss';
import { ReactComponent as GiftIcon } from 'assets/icons/gift-icon.svg';
import { ReactComponent as SetBudgetIcon } from 'assets/icons/set-budget.svg';

import { DeleteIcon } from 'cokitchen-icons';
import { useNavigate } from 'react-router';
import { ROUTE_KEYS } from 'utils/constants';
import { MemberListType } from 'models/member.model';
const PeopleTableBulkActions = ({
  people,
  deleteFunc,
  selectAllFunc,
  showBulkActions,
  setShowBulkActions,
  setSelectedPeople,
  setShowBudgetSettingsModal
}: {
  people: any;
  deleteFunc: (arg1: any) => void;
  selectAllFunc: () => void;
  showBulkActions: boolean;
  setShowBulkActions: (arg1: boolean) => void;
  setSelectedPeople: (arg1: MemberListType[]) => void;
  setShowBudgetSettingsModal: (arg1: boolean) => void;
}) => {
  const navigate = useNavigate();

  return (
    <div className='w-11/12 max-w-[600px] fixed bottom-5 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
      {showBulkActions && (
        <div className='bulk-actions bg-white flex flex-wrap items-center justify-start gap-4 rounded-full py-5 px-[22px]'>
          <p className='text-[#6F7376] text-sm'>{people.length} people</p>
          <button
            onClick={() => selectAllFunc()}
            className='cursor-pointer text-xs bg-[#F2F2F2] rounded-[8px] h-[29px] text-[#585F68] px-[12px] py-[6px]'>
            Select All
          </button>
          <button
            className='cursor-pointer flex justify-between flex-nowrap items-center gap-1 text-xs bg-[#F2F2F2] rounded-[8px] text-[#585F68] px-[12px] py-[6px] h-[29px]'
            onClick={() => setShowBudgetSettingsModal(true)}>
            <SetBudgetIcon className='w-4 h-4' color='currentColor' />
            Set Budget
          </button>
          <button
            onClick={() => navigate(`${ROUTE_KEYS.APP}/${ROUTE_KEYS.GIFT_BULK_MEMBERS}`)}
            className='cursor-pointer flex justify-between items-center gap-1 text-xs bg-[#F2F2F2] rounded-[8px] text-[#585F68] px-[12px] py-[6px] h-[29px]'>
            <GiftIcon className='w-4 h-4' color='currentColor' />
            Gift
          </button>
          <button
            onClick={() => {
              deleteFunc(people);
            }}
            className='cursor-pointer flex justify-between items-center gap-1 text-xs bg-[#F2F2F2] rounded-[8px] text-[#585F68] px-[12px] py-[6px] h-[29px]'>
            <DeleteIcon className='w-4 h-4' color='currentColor' />
            Delete
          </button>
          <button
            onClick={() => {
              setShowBulkActions(false);
              setSelectedPeople([]);
            }}
            className='cursor-pointer text-xs bg-[#E60A2B] rounded-[8px] text-white px-[12px] py-[6px] h-[29px]'>
            Cancel
          </button>
        </div>
      )}
    </div>
  );
};

export default PeopleTableBulkActions;
